export default __webpack_public_path__ + "locales/hy-AM/SingleSignOn.json?hash=a0516999b8324065c3cf0cec947cd2ef";